function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["tag", "isFluid", "rootClassName"],
  _excluded2 = ["tag", "rootClassName", "noGutter", "alignItems", "alignContent", "justifyContent"],
  _excluded3 = ["tag", "rootClassName", "noGutter", "col", "xs", "sm", "md", "lg", "xl", "xxl", "offset", "xsOffset", "smOffset", "mdOffset", "lgOffset", "xlOffset", "xxlOffset", "push", "xsPush", "smPush", "mdPush", "lgPush", "xlPush", "xxlPush", "pull", "xsPull", "smPull", "mdPull", "lgPull", "xlPull", "xxlPull", "order", "xsOrder", "smOrder", "mdOrder", "lgOrder", "xlOrder", "xxlOrder", "flexDirection", "xsFlexDirection", "smFlexDirection", "mdFlexDirection", "lgFlexDirection", "xlFlexDirection", "xxlFlexDirection", "flexWrap", "xsFlexWrap", "smFlexWrap", "mdFlexWrap", "lgFlexWrap", "xlFlexWrap", "xxlFlexWrap", "justifyContent", "xsJustifyContent", "smJustifyContent", "mdJustifyContent", "lgJustifyContent", "xlJustifyContent", "xxlJustifyContent", "alignItems", "xsAlignItems", "smAlignItems", "mdAlignItems", "lgAlignItems", "xlAlignItems", "xxlAlignItems", "alignSelf", "xsAlignSelf", "smAlignSelf", "mdAlignSelf", "lgAlignSelf", "xlAlignSelf", "xxlAlignSelf"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
//
/* eslint-disable no-use-before-define, quote-props */
import * as React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css, breakPoint, containerMaxWidth } from "../../styles/theme";
import { alignContentProps, alignItemsProps, justifyContentProps, alignSelfProps, flexDirectionProps, flexWrapProps, orderProps, array0To12Props, columnProps } from "../../constants/flexPropTypes";
var BASE = 6;
var BASE_FACTOR = 2;
var BASE_SPACING = BASE * BASE_FACTOR;
var FLEX_COL = ['0', '8.333333%', '16.666667%', '25%', '33.333333%', '41.666667%', '50%', '58.333333%', '66.666667%', '75%', '83.333333%', '91.666667%', '100%'];
var isValid = function isValid(input) {
  return !!input || input === 0;
};

// TODO: Add type information for ...rest parameters
export function Container(_ref) {
  var tag = _ref.tag,
    isFluid = _ref.isFluid,
    rootClassName = _ref.rootClassName,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag === undefined || tag === null ? 'div' : tag;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.Container, !isFluid && styles.container), rest));
}
Container.defaultProps = {
  tag: 'div'
};
Container.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  isFluid: PropTypes.bool,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export function Row(_ref2) {
  var Tag = _ref2.tag,
    rootClassName = _ref2.rootClassName,
    noGutter = _ref2.noGutter,
    alignItems = _ref2.alignItems,
    alignContent = _ref2.alignContent,
    justifyContent = _ref2.justifyContent,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.Row, noGutter && styles.noGutterRow, alignContent && styles["".concat(alignContent, "AlignContent")], alignItems && styles["".concat(alignItems, "Align")], justifyContent && styles["".concat(justifyContent, "Justify")]), rest));
}
Row.defaultProps = {
  tag: 'div'
};
Row.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  noGutter: PropTypes.bool,
  alignContent: alignContentProps,
  alignItems: alignItemsProps,
  justifyContent: justifyContentProps
};
export function Col(_ref3) {
  var Tag = _ref3.tag,
    rootClassName = _ref3.rootClassName,
    noGutter = _ref3.noGutter,
    col = _ref3.col,
    xs = _ref3.xs,
    sm = _ref3.sm,
    md = _ref3.md,
    lg = _ref3.lg,
    xl = _ref3.xl,
    xxl = _ref3.xxl,
    offset = _ref3.offset,
    xsOffset = _ref3.xsOffset,
    smOffset = _ref3.smOffset,
    mdOffset = _ref3.mdOffset,
    lgOffset = _ref3.lgOffset,
    xlOffset = _ref3.xlOffset,
    xxlOffset = _ref3.xxlOffset,
    push = _ref3.push,
    xsPush = _ref3.xsPush,
    smPush = _ref3.smPush,
    mdPush = _ref3.mdPush,
    lgPush = _ref3.lgPush,
    xlPush = _ref3.xlPush,
    xxlPush = _ref3.xxlPush,
    pull = _ref3.pull,
    xsPull = _ref3.xsPull,
    smPull = _ref3.smPull,
    mdPull = _ref3.mdPull,
    lgPull = _ref3.lgPull,
    xlPull = _ref3.xlPull,
    xxlPull = _ref3.xxlPull,
    order = _ref3.order,
    xsOrder = _ref3.xsOrder,
    smOrder = _ref3.smOrder,
    mdOrder = _ref3.mdOrder,
    lgOrder = _ref3.lgOrder,
    xlOrder = _ref3.xlOrder,
    xxlOrder = _ref3.xxlOrder,
    flexDirection = _ref3.flexDirection,
    xsFlexDirection = _ref3.xsFlexDirection,
    smFlexDirection = _ref3.smFlexDirection,
    mdFlexDirection = _ref3.mdFlexDirection,
    lgFlexDirection = _ref3.lgFlexDirection,
    xlFlexDirection = _ref3.xlFlexDirection,
    xxlFlexDirection = _ref3.xxlFlexDirection,
    flexWrap = _ref3.flexWrap,
    xsFlexWrap = _ref3.xsFlexWrap,
    smFlexWrap = _ref3.smFlexWrap,
    mdFlexWrap = _ref3.mdFlexWrap,
    lgFlexWrap = _ref3.lgFlexWrap,
    xlFlexWrap = _ref3.xlFlexWrap,
    xxlFlexWrap = _ref3.xxlFlexWrap,
    justifyContent = _ref3.justifyContent,
    xsJustifyContent = _ref3.xsJustifyContent,
    smJustifyContent = _ref3.smJustifyContent,
    mdJustifyContent = _ref3.mdJustifyContent,
    lgJustifyContent = _ref3.lgJustifyContent,
    xlJustifyContent = _ref3.xlJustifyContent,
    xxlJustifyContent = _ref3.xxlJustifyContent,
    alignItems = _ref3.alignItems,
    xsAlignItems = _ref3.xsAlignItems,
    smAlignItems = _ref3.smAlignItems,
    mdAlignItems = _ref3.mdAlignItems,
    lgAlignItems = _ref3.lgAlignItems,
    xlAlignItems = _ref3.xlAlignItems,
    xxlAlignItems = _ref3.xxlAlignItems,
    alignSelf = _ref3.alignSelf,
    xsAlignSelf = _ref3.xsAlignSelf,
    smAlignSelf = _ref3.smAlignSelf,
    mdAlignSelf = _ref3.mdAlignSelf,
    lgAlignSelf = _ref3.lgAlignSelf,
    xlAlignSelf = _ref3.xlAlignSelf,
    xxlAlignSelf = _ref3.xxlAlignSelf,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, css(rootClassName, styles.Col, noGutter && styles.noGutterCol, isValid(col) && styles["Col".concat(col.toString())], isValid(xs) && styles["xsCol".concat(xs.toString())], isValid(sm) && styles["smCol".concat(sm.toString())], isValid(md) && styles["mdCol".concat(md.toString())], isValid(lg) && styles["lgCol".concat(lg.toString())], isValid(xl) && styles["xlCol".concat(xl.toString())], isValid(xxl) && styles["xxlCol".concat(xxl.toString())], isValid(offset) && styles["ColOffset".concat(offset)], isValid(xsOffset) && styles["xsColOffset".concat(xsOffset)], isValid(smOffset) && styles["smColOffset".concat(smOffset)], isValid(mdOffset) && styles["mdColOffset".concat(mdOffset)], isValid(lgOffset) && styles["lgColOffset".concat(lgOffset)], isValid(xlOffset) && styles["xlColOffset".concat(xlOffset)], isValid(xxlOffset) && styles["xxlColOffset".concat(xxlOffset)], isValid(push) && styles["ColPush".concat(push)], isValid(xsPush) && styles["xsColPush".concat(xsPush)], isValid(smPush) && styles["smColPush".concat(smPush)], isValid(mdPush) && styles["mdColPush".concat(mdPush)], isValid(lgPush) && styles["lgColPush".concat(lgPush)], isValid(xlPush) && styles["xlColPush".concat(xlPush)], isValid(xxlPush) && styles["xxlColPush".concat(xxlPush)], isValid(pull) && styles["colPull".concat(pull)], isValid(xsPull) && styles["xsColPull".concat(xsPull)], isValid(smPull) && styles["smColPull".concat(smPull)], isValid(mdPull) && styles["mdColPull".concat(mdPull)], isValid(lgPull) && styles["lgColPull".concat(lgPull)], isValid(xlPull) && styles["xlColPull".concat(xlPull)], isValid(xxlPull) && styles["xxlColPull".concat(xxlPull)], order && styles["Order".concat(order)], xsOrder && styles["xsOrder".concat(xsOrder)], smOrder && styles["smOrder".concat(smOrder)], mdOrder && styles["mdOrder".concat(mdOrder)], lgOrder && styles["lgOrder".concat(lgOrder)], xlOrder && styles["xlOrder".concat(xlOrder)], xxlOrder && styles["xxlOrder".concat(xxlOrder)], flexDirection && styles["Direction".concat(flexDirection)], xsFlexDirection && styles["xsFlexDirection".concat(xsFlexDirection)], smFlexDirection && styles["smFlexDirection".concat(smFlexDirection)], mdFlexDirection && styles["mdFlexDirection".concat(mdFlexDirection)], lgFlexDirection && styles["lgFlexDirection".concat(lgFlexDirection)], xlFlexDirection && styles["xlFlexDirection".concat(xlFlexDirection)], xxlFlexDirection && styles["xxlFlexDirection".concat(xxlFlexDirection)], flexWrap && styles["Wrap".concat(flexWrap)], xsFlexWrap && styles["xsFlexWrap".concat(xsFlexWrap)], smFlexWrap && styles["smFlexWrap".concat(smFlexWrap)], mdFlexWrap && styles["mdFlexWrap".concat(mdFlexWrap)], lgFlexWrap && styles["lgFlexWrap".concat(lgFlexWrap)], xlFlexWrap && styles["xlFlexWrap".concat(xlFlexWrap)], xxlFlexWrap && styles["xxlFlexWrap".concat(xxlFlexWrap)], justifyContent && styles["Justify".concat(justifyContent)], xsJustifyContent && styles["xsJustify".concat(xsJustifyContent)], smJustifyContent && styles["smJustify".concat(smJustifyContent)], mdJustifyContent && styles["mdJustify".concat(mdJustifyContent)], lgJustifyContent && styles["lgJustify".concat(lgJustifyContent)], xlJustifyContent && styles["xlJustify".concat(xlJustifyContent)], xxlJustifyContent && styles["xxlJustify".concat(xxlJustifyContent)], alignItems && styles["AlignItems".concat(alignItems)], xsAlignItems && styles["xsAlignItems".concat(xsAlignItems)], smAlignItems && styles["smAlignItems".concat(smAlignItems)], mdAlignItems && styles["mdAlignItems".concat(mdAlignItems)], lgAlignItems && styles["lgAlignItems".concat(lgAlignItems)], xlAlignItems && styles["xlAlignItems".concat(xlAlignItems)], xxlAlignItems && styles["xxlAlignItems".concat(xxlAlignItems)], alignSelf && styles["AlignSelf".concat(alignSelf)], xsAlignSelf && styles["xsAlignSelf".concat(xsAlignSelf)], smAlignSelf && styles["smAlignSelf".concat(smAlignSelf)], mdAlignSelf && styles["mdAlignSelf".concat(mdAlignSelf)], lgAlignSelf && styles["lgAlignSelf".concat(lgAlignSelf)], xlAlignSelf && styles["xlAlignSelf".concat(xlAlignSelf)], xxlAlignSelf && styles["xxlAlignSelf".concat(xxlAlignSelf)]), rest));
}
Col.defaultProps = {
  tag: 'div'
};
Col.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  noGutter: PropTypes.bool,
  col: columnProps,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  xxl: columnProps,
  offset: array0To12Props,
  xsOffset: array0To12Props,
  smOffset: array0To12Props,
  mdOffset: array0To12Props,
  lgOffset: array0To12Props,
  xlOffset: array0To12Props,
  xxlOffset: array0To12Props,
  push: array0To12Props,
  xsPush: array0To12Props,
  smPush: array0To12Props,
  mdPush: array0To12Props,
  lgPush: array0To12Props,
  xlPush: array0To12Props,
  xxlPush: array0To12Props,
  pull: array0To12Props,
  xsPull: array0To12Props,
  smPull: array0To12Props,
  mdPull: array0To12Props,
  lgPull: array0To12Props,
  xlPull: array0To12Props,
  xxlPull: array0To12Props,
  order: orderProps,
  xsOrder: orderProps,
  smOrder: orderProps,
  mdOrder: orderProps,
  lgOrder: orderProps,
  xlOrder: orderProps,
  xxlOrder: orderProps,
  flexDirection: flexDirectionProps,
  xsFlexDirection: flexDirectionProps,
  smFlexDirection: flexDirectionProps,
  mdFlexDirection: flexDirectionProps,
  lgFlexDirection: flexDirectionProps,
  xlFlexDirection: flexDirectionProps,
  xxlFlexDirection: flexDirectionProps,
  flexWrap: flexWrapProps,
  xsFlexWrap: flexWrapProps,
  smFlexWrap: flexWrapProps,
  mdFlexWrap: flexWrapProps,
  lgFlexWrap: flexWrapProps,
  xlFlexWrap: flexWrapProps,
  xxlFlexWrap: flexWrapProps,
  justifyContent: justifyContentProps,
  xsJustifyContent: justifyContentProps,
  smJustifyContent: justifyContentProps,
  mdJustifyContent: justifyContentProps,
  lgJustifyContent: justifyContentProps,
  xlJustifyContent: justifyContentProps,
  xxlJustifyContent: justifyContentProps,
  alignItems: alignItemsProps,
  xsAlignItems: alignItemsProps,
  smAlignItems: alignItemsProps,
  mdAlignItems: alignItemsProps,
  lgAlignItems: alignItemsProps,
  xlAlignItems: alignItemsProps,
  xxlAlignItems: alignItemsProps,
  alignSelf: alignSelfProps,
  xsAlignSelf: alignSelfProps,
  smAlignSelf: alignSelfProps,
  mdAlignSelf: alignSelfProps,
  lgAlignSelf: alignSelfProps,
  xlAlignSelf: alignSelfProps,
  xxlAlignSelf: alignSelfProps
};
function getContainer(size) {
  return _defineProperty({}, "@media (min-width: ".concat(breakPoint[size], "px)"), {
    width: containerMaxWidth[size]
  });
}
function getMediaQuery(size, styleObj) {
  return size ? _defineProperty({}, "@media (min-width: ".concat(breakPoint[size], "px)"), styleObj) : styleObj;
}
function getColDefault(size) {
  var styleObj = {
    flexGrow: 1,
    flexBasis: 0,
    maxWidth: '100%'
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getColAuto(size) {
  var styleObj = {
    flex: '0 0 auto',
    width: 'auto'
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getCol(colNum, size) {
  var styleObj = {
    width: FLEX_COL[colNum]
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getColPull(colNum, size) {
  var styleObj = {
    right: FLEX_COL[colNum]
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getColPush(colNum, size) {
  var styleObj = {
    left: FLEX_COL[colNum]
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getColOffset(colNum, size) {
  var styleObj = {
    marginLeft: FLEX_COL[colNum]
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getOrder(order, size) {
  var styleObj = {
    order: order
  };
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getFlexFlow(_ref6, size) {
  var isRow = _ref6.isRow,
    isRowReverse = _ref6.isRowReverse,
    isColumn = _ref6.isColumn,
    isColumnReverse = _ref6.isColumnReverse,
    wrap = _ref6.wrap,
    nowrap = _ref6.nowrap,
    wrapReverse = _ref6.wrapReverse;
  var styleObj = {};
  if (isRow) {
    styleObj.flexDirection = 'row';
  } else if (isRowReverse) {
    styleObj.flexDirection = 'row-reverse';
  } else if (isColumn) {
    styleObj.flexDirection = 'column';
  } else if (isColumnReverse) {
    styleObj.flexDirection = 'column-reverse';
  }
  if (wrap) {
    styleObj.flexWrap = 'wrap';
  } else if (nowrap) {
    styleObj.flexWrap = 'nowrap';
  } else if (wrapReverse) {
    styleObj.wrapReverse = 'wrap-reverse';
  }
  return size ? getMediaQuery(size, styleObj) : styleObj;
}
function getSharedColStyles(size) {
  var _ref7;
  return _ref7 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "Coltrue"), getColDefault(size)), "".concat(size, "Colauto"), getColAuto(size)), "".concat(size, "Col1"), getCol(1, size)), "".concat(size, "Col2"), getCol(2, size)), "".concat(size, "Col3"), getCol(3, size)), "".concat(size, "Col4"), getCol(4, size)), "".concat(size, "Col5"), getCol(5, size)), "".concat(size, "Col6"), getCol(6, size)), "".concat(size, "Col7"), getCol(7, size)), "".concat(size, "Col8"), getCol(8, size)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "Col9"), getCol(9, size)), "".concat(size, "Col10"), getCol(10, size)), "".concat(size, "Col11"), getCol(11, size)), "".concat(size, "Col12"), getCol(12, size)), "".concat(size, "ColPull0"), {
    right: 'auto'
  }), "".concat(size, "ColPull1"), getColPull(1, size)), "".concat(size, "ColPull2"), getColPull(2, size)), "".concat(size, "ColPull3"), getColPull(3, size)), "".concat(size, "ColPull4"), getColPull(4, size)), "".concat(size, "ColPull5"), getColPull(5, size)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "ColPull6"), getColPull(6, size)), "".concat(size, "ColPull7"), getColPull(7, size)), "".concat(size, "ColPull8"), getColPull(8, size)), "".concat(size, "ColPull9"), getColPull(9, size)), "".concat(size, "ColPull10"), getColPull(10, size)), "".concat(size, "ColPull11"), getColPull(11, size)), "".concat(size, "ColPull12"), getColPull(12, size)), "".concat(size, "ColPush0"), {
    left: 'auto'
  }), "".concat(size, "ColPush1"), getColPush(1, size)), "".concat(size, "ColPush2"), getColPush(2, size)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "ColPush3"), getColPush(3, size)), "".concat(size, "ColPush4"), getColPush(4, size)), "".concat(size, "ColPush5"), getColPush(5, size)), "".concat(size, "ColPush6"), getColPush(6, size)), "".concat(size, "ColPush7"), getColPush(7, size)), "".concat(size, "ColPush8"), getColPush(8, size)), "".concat(size, "ColPush9"), getColPush(9, size)), "".concat(size, "ColPush10"), getColPush(10, size)), "".concat(size, "ColPush11"), getColPush(11, size)), "".concat(size, "ColPush12"), getColPush(12, size)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "ColOffset0"), getColOffset(0, size)), "".concat(size, "ColOffset1"), getColOffset(1, size)), "".concat(size, "ColOffset2"), getColOffset(2, size)), "".concat(size, "ColOffset3"), getColOffset(3, size)), "".concat(size, "ColOffset4"), getColOffset(4, size)), "".concat(size, "ColOffset5"), getColOffset(5, size)), "".concat(size, "ColOffset6"), getColOffset(6, size)), "".concat(size, "ColOffset7"), getColOffset(7, size)), "".concat(size, "ColOffset8"), getColOffset(8, size)), "".concat(size, "ColOffset9"), getColOffset(9, size)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "ColOffset10"), getColOffset(10, size)), "".concat(size, "ColOffset11"), getColOffset(11, size)), "".concat(size, "ColOffset12"), getColOffset(12, size)), "".concat(size, "Order-1"), getOrder(-1, size)), "".concat(size, "Order1"), getOrder(1, size)), "".concat(size, "Order0"), getOrder(0, size)), "".concat(size, "FlexDirectionrow"), getFlexFlow({
    isRow: true
  }, size)), "".concat(size, "FlexDirectioncolumn"), getFlexFlow({
    isColumn: true
  }, size)), "".concat(size, "FlexDirectionrow-reverse"), getFlexFlow({
    isRowReverse: true
  }, size)), "".concat(size, "FlexDirectioncolumn-reverse"), getFlexFlow({
    isColumnReverse: true
  }, size)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "FlexWrapwrap"), getFlexFlow({
    wrap: true
  }, size)), "".concat(size, "FlexWrapnowrap"), getFlexFlow({
    nowrap: true
  }, size)), "".concat(size, "FlexWrapwrap-reverse"), getFlexFlow({
    wrapReverse: true
  }, size)), "".concat(size, "Justifystart"), getMediaQuery(size, {
    justifyContent: 'flex-start'
  })), "".concat(size, "Justifycenter"), getMediaQuery(size, {
    justifyContent: 'center'
  })), "".concat(size, "Justifyend"), getMediaQuery(size, {
    justifyContent: 'flex-end'
  })), "".concat(size, "Justifyaround"), getMediaQuery(size, {
    justifyContent: 'space-around'
  })), "".concat(size, "Justifybetween"), getMediaQuery(size, {
    justifyContent: 'space-between'
  })), "".concat(size, "AlignItemsstart"), getMediaQuery(size, {
    alignItems: 'flex-start'
  })), "".concat(size, "AlignItemscenter"), getMediaQuery(size, {
    alignItems: 'center'
  })), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref7, "".concat(size, "AlignItemsend"), getMediaQuery(size, {
    alignItems: 'flex-end'
  })), "".concat(size, "AlignSelfstart"), getMediaQuery(size, {
    alignSelf: 'flex-start'
  })), "".concat(size, "AlignSelfcenter"), getMediaQuery(size, {
    alignSelf: 'center'
  })), "".concat(size, "AlignSelfend"), getMediaQuery(size, {
    alignSelf: 'flex-end'
  })), "".concat(size, "AlignSelfstretch"), getMediaQuery(size, {
    alignSelf: 'stretch'
  })), "".concat(size, "AlignSelfbaseline"), getMediaQuery(size, {
    alignSelf: 'baseline'
  }));
}
var SHARED_STYLES = {
  afterStyle: {
    ':after': {
      content: '',
      display: 'table',
      clear: 'both'
    }
  }
};
var styles = StyleSheet.create(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  Container: _objectSpread({
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: BASE_SPACING,
    paddingRight: BASE_SPACING
  }, SHARED_STYLES.afterStyle),
  container: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getContainer('sm')), getContainer('md')), getContainer('lg')), getContainer('xl')), getContainer('xxl')),
  isFluid: {},
  Row: _objectSpread({
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: -BASE_SPACING,
    marginRight: -BASE_SPACING
  }, SHARED_STYLES.afterStyle),
  noGutterRow: {
    marginLeft: 0,
    marginRight: 0
  },
  noGutterCol: {
    paddingLeft: 0,
    paddingRight: 0
  },
  startJustify: {
    justifyContent: 'flex-start'
  },
  centerJustify: {
    justifyContent: 'center'
  },
  endJustify: {
    justifyContent: 'flex-end'
  },
  aroundJustify: {
    justifyContent: 'space-around'
  },
  betweenJustify: {
    justifyContent: 'space-between'
  },
  startAlign: {
    alignItems: 'flex-start'
  },
  endAlign: {
    alignItems: 'flex-end'
  },
  centerAlign: {
    alignItems: 'center'
  },
  baselineAlign: {
    alignItems: 'baseline'
  },
  stretchAlign: {
    alignItems: 'stretch'
  },
  startAlignContent: {
    alignContent: 'flex-start'
  },
  endAlignContent: {
    alignContent: 'flex-end'
  },
  centerAlignContent: {
    alignContent: 'center'
  },
  betweenAlignContent: {
    alignContent: 'between'
  },
  aroundAlignContent: {
    alignContent: 'around'
  },
  stretchAlignContent: {
    alignContent: 'stretch'
  },
  Col: _objectSpread({
    position: 'relative',
    minHeight: 1,
    width: '100%',
    paddingLeft: BASE_SPACING,
    paddingRight: BASE_SPACING
  }, SHARED_STYLES.afterStyle)
}, getSharedColStyles('')), getSharedColStyles('xs')), getSharedColStyles('sm')), getSharedColStyles('md')), getSharedColStyles('lg')), getSharedColStyles('xl')), getSharedColStyles('xxl')));